/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Blog_View_AllInputs */

const en_landing_blog_view_all = /** @type {(inputs: Landing_Blog_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all posts`)
};

const zh_landing_blog_view_all = /** @type {(inputs: Landing_Blog_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看全部文章`)
};

/**
* | output |
* | --- |
* | "View all posts" |
*
* @param {Landing_Blog_View_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_blog_view_all = /** @type {((inputs?: Landing_Blog_View_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Blog_View_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_blog_view_all(inputs)
	return zh_landing_blog_view_all(inputs)
});
export { landing_blog_view_all as "landing.blog.view_all" }